/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { deleteCardRecordsUseItems, getCardRecordsPurchase } from "../../../../apis/finances/cards";
import { ControlTable } from "../../../../components/Table";
import systemAlert from "../../../../utils/systemAlert";
import Comment from "../../../../components/Comment";
import Modal, { ModalHeader } from "../../../../components/Modal";
import Button from "../../../../components/Button";
import { translation } from "../../../../utils/translator";
import { CARD_DATA } from "../../../../constants/CARD_DATA";
import { classnames } from "../../../../utils/text";
import { isVerticalImg } from "../../../../utils/image";
import defaultCardImage from "../../../../assets/images/bank-card-images/default-card-img.png"
import { cardName } from "../../../../utils/account-name";
import CardRelatedModal from "../CardRelatedListModal";
import { transformComNum } from "../../../../utils/validator/comNum";
import { dateToViewFormat } from "../../../../utils/date";
import DataComponent from "../../../../components/DataComponent";
import { TASK_STATUS_LIST } from "../../../../constants/TASK";
import { PAYMENT_TYPE } from "../../../../constants/EXPENSE";
import Profile from "../../../../components/Profile";
import { useSelector } from "react-redux";

const PurchaseDetail = ({ open, setOpen, data, permission, submit }) => {
  const [fields] = useState([
    { title: "거래일자", key: "useTime", type: "date" },
    { title: "결제금액", key: "useAmt", type: "comma" },
    { title: "거래타입", key: "useDiv" },
    { title: "상태", key: "apprSt" },
    { title: "가맹점", key: "useStore" },
    { title: "업종", key: "storeType" },
    { title: "사업자번호", key: "storeBizNo" },
    { title: "가맹점 전화번호", key: "storeTel" },
    {
      title: '카테고리',
      key: 'accountingTitleUses',
      onValue: (value) => {
        return (
          !isEmpty(value) &&
          value.map((category, idx) => (
            <div className="text-align-right" key={idx}>
              <p className="pt-8 pb-8">
                <span className="vertical-middle">{category.accountingTitle.name}</span>
              </p>
            </div>
          ))
        )
      }
    }]);
  const [list, setList] = useState([])
  const [relatedListOpen, setRelatedListOpen] = useState(false)
  const [bankTransFields] = useState([
    { title: "거래일자", key: "bankTrans.tradeTime", type: "date" },
    { title: "계좌정보", key: "bankTrans.bankName" },
    { title: "입금액", key: "bankTrans.inAmt", type: 'comma', className: "color-red-100" },
    { title: "출금액", key: "bankTrans.outAmt", type: 'comma', className: "color-purple-100" },
    { title: "적요", key: "bankTrans.traderName" },
    {
      title: "거래처", key: "bankTrans.clients", onValue: (value, field, data) => {
        return (
          !isEmpty(value) &&
          value.map((client, idx) => (
            <p className="pt-8 pb-8" key={idx}>
              <span className="vertical-middle">{client.name}</span>
            </p>
          ))
        )
      }
    },
  ]);
  const [bankTransList, setBankTransList] = useState([])
  const [invoiceFields] = useState([
    { title: "일자", key: "invoice.writeDate", type: 'date' },
    { title: "상호", key: "invoice.supCorpName" },
    { title: "대표자명", key: "invoice.supRepName" },
    {
      title: "사업자번호",
      key: "invoice.supBizNo",
      onValue: (value) => {
        return transformComNum(value)
      }
    },
    {
      title: "공급가액",
      key: "invoice.supplyAmt",
      type: 'comma'
    },
    {
      title: "세액",
      key: "invoice.taxAmt",
      type: 'comma'
    },
    {
      title: "합계금액",
      key: "invoice.totalAmt",
      type: 'comma'
    },
    {
      title: "발행여부",
      key: "invoice.taxInvoiceIdx",
      onValue: (value, field, form) => {
        let issue = "";
        if (isEmpty(value)) {
          issue = "부";
        } else {
          // TODO 나중에 현금영수증 발급 추가 될 경우... 변경해야함
          issue = "세금계산서"
        }

        return issue;
      },
    },
  ]);
  const [invoiceList, setInvoiceList] = useState([])
  const [expenseFields] = useState([
    {
      title: "작성일시",
      key: "expense.createdTime",
      onValue: (value) => {
        return (
          <div className="list-date-wrap">
            <p className="list-date">{dateToViewFormat(value)}</p>
            <p className="list-date-time">{dateToViewFormat(value, "HH:mm")}</p>
          </div>
        );
      },
    },
    {
      title: "작성자",
      key: "expense.reqEmployeeIdx",
      onValue: (value) => {
        return (
          <Profile
            employeeIdx={value} />
        )
      },
    },
    {
      title: "타입",
      key: "expense.payType",
      onTranslator: {
        list: PAYMENT_TYPE,
      },
    },
    { title: "합계금액", key: "expense.useAmt", type: "comma" },
    { title: "비용항목", key: "expense.expenseOptionName" },
    {
      title: "결재상태",
      key: "expense.apprStatus",
      onValue: (value) => {
        const target = TASK_STATUS_LIST.find(
          (vacation) => vacation.status === value
        );
        return (
          <DataComponent
            field={{
              type: "badge",
              color: target.color,
              label: target.label,
            }}
          />
        );
      },
    },
  ])
  const [expenseList, setExpenseList] = useState([])
  const [taskFields] = useState([
    {
      title: "상태",
      key: "expense.apprStatus",
      onValue: (value) => {
        const target = TASK_STATUS_LIST.find(
          (vacation) => vacation.status === value
        );
        return (
          <DataComponent
            field={{
              type: "badge",
              color: target.color,
              label: target.label,
            }}
          />
        );
      },
    },
    {
      title: '유형',
      onValue: () => {
        return '경비청구'
      }
    },
    {
      title: "티켓 명",
      key: "expense.title",
      type: 'ellipsis',
    },
    {
      title: "발행일",
      type: 'date',
      key: "expense.createdTime",
      sort: "desc",
    },
    {
      title: "작성자",
      key: "expense.reqEmployeeIdx",
      type: 'profile',
    },
  ])
  const [taskList, setTaskList] = useState([])
  // 연관 항목 권한
  const [targetPermission, setTargetPermission] = useState([])
  const { permissions } = useSelector((store) => ({
    permissions: store.Profile.permissions
  }));

  useEffect(() => {
    if (open) {
      // 관련항목 권한체크
      const permissionTarget = ['TRADE_INVOICE', 'FUND_BANK_HISTORY', 'EXPENSE']
      const targetPermissions = permissions.filter((p) => permissionTarget.includes(p.code))
      setTargetPermission(targetPermissions)
    }
  }, [permissions, open])

  useEffect(() => {
    _submit()
  }, [data])

  const _submit = () => {
    getCardRecordsPurchase(data.idx).then((res) => {
      const { cardUseItems, psnlCardExpenses, corpCardExpenses } = res.data.cardPurchase
      setList([res.data.cardPurchase])
      const bankTransList = cardUseItems.filter(item => item.itemType === "bank_trans")
      const invoiceList = cardUseItems.filter(item => item.itemType === "invoice")
      const expenseList = cardUseItems.filter(item => item.itemType === "expense")
      setBankTransList(bankTransList)
      setInvoiceList(invoiceList)
      setExpenseList(expenseList)
      setTaskList([...psnlCardExpenses, ...corpCardExpenses])
    })
  }

  const rowBtnConfig = {
    rowButtons: [
      {
        label: "삭제",
        type: "delete",
        className: "margin-right-8",
        action: (rowData) => {
          const { idx } = rowData
          systemAlert('해당 연관 데이터를 삭제하시겠습니까?', {
            buttons: [
              {
                color: 'text',
                label: '취소'
              },
              {
                label: '삭제',
                onClick: () => {
                  deleteCardRecordsUseItems(idx).then(() => {
                    _submit()
                  })
                }
              }
            ]
          })
        },
      },
    ],
  };

  const cancel = () => {
    setOpen(false)
  }

  const getTitle = (data) => {
    const { cardImg, cardNo, cardCd } = data
    const cardCompany = translation(CARD_DATA, cardCd, "code", "name")
    return (
      <div className="inline-block text-align-left">
        <div
          className={classnames("card-img-wrap", {
            vertical: isVerticalImg(cardImg),
          })}
        >
          <img src={cardImg || defaultCardImage} alt={cardCompany} onError={(e) => e.target.src = defaultCardImage} />
        </div>
        <span
          className="card-name"
        >
          {`${cardName(cardCompany, cardNo)}`}
          <span className="ml-4">매입 건별 상세내역</span>
        </span>
      </div>
    )
  }


  return (
    <>
      {!relatedListOpen && (
        <Modal isOpen={open} close={cancel}>
          <div className="card-summaries-detail">
            <ModalHeader>{getTitle(data.cardInfo)}</ModalHeader>
            <ControlTable fields={fields} list={list} />
            <div className="related-container">
              {permission.level > 1 && (
                <div className="related-header">
                  <Button
                    className="add-related-btn"
                    size="sm"
                    color="line"
                    label="관련항목 추가"
                    disabled={isEmpty(targetPermission)}
                    onClick={() => setRelatedListOpen(true)}
                  />
                </div>
              )}
              {!isEmpty(taskList) && (
                <div className="related-body">
                  <label className="related-header-title">
                    매핑된 할일 내역
                  </label>
                  <ControlTable fields={taskFields} list={taskList} />
                </div>
              )}
              {!isEmpty(bankTransList) && (
                <div className="related-body">
                  <label className="related-header-title">
                    연관 은행 입출금 내역
                  </label>
                  <ControlTable fields={bankTransFields} list={bankTransList} rowBtn={permission.level > 1 ? rowBtnConfig : {}} />
                </div>
              )}
              {!isEmpty(invoiceList) && (
                <div className="related-body">
                  <label className="related-header-title">
                    연관 거래명세서 내역
                  </label>
                  <ControlTable fields={invoiceFields} list={invoiceList} rowBtn={permission.level > 1 ? rowBtnConfig : {}} />
                </div>
              )}
              {!isEmpty(expenseList) && (
                <div className="related-body">
                  <label className="related-header-title">
                    연관 경비청구 내역
                  </label>
                  <ControlTable fields={expenseFields} list={expenseList} rowBtn={permission.level > 1 ? rowBtnConfig : {}} />
                </div>
              )}
            </div>
            <div className="margin-top-24">
              <Comment
                postIdx={data.idx}
                postType={"card_purchase"}
                submit={submit}
              />
            </div>
            <div className="margin-top-20">
              <Button className="close-button" label="닫기" onClick={cancel} />
            </div>
          </div>
        </Modal>
      )}
      {relatedListOpen && (
        <CardRelatedModal open={relatedListOpen} setOpen={setRelatedListOpen} type="purchase" data={list[0]} submit={_submit} permissions={targetPermission} />
      )}
    </>
  );
};

export default PurchaseDetail;
